import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../constants';
import { Container, Button, Spinner } from 'react-bootstrap';
import { CheckCircle, XCircle } from 'react-bootstrap-icons';

function Activation() {
  const { activationCode } = useParams();
  const [activationStatus, setActivationStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const activateUser = async () => {
      try {
        const response = await axios.post(`${BASE_URL}/users/verifyuser/${activationCode}`);
        setActivationStatus({ success: true, message: response.data.message });
      } catch (error) {
        setActivationStatus({
          success: false,
          message: error.response?.data?.message || 'Something went wrong. Please try again.',
        });
      } finally {
        setLoading(false);
      }
    };

    activateUser();
  }, [activationCode]);

  return (
    <Container className="d-flex justify-content-center align-items-center min-vh-100">
      <div
        className="p-5 shadow rounded"
        style={{
          width: '100%',
          maxWidth: '500px',
          backgroundColor: 'white',
          textAlign: 'center',
        }}
      >
        {loading ? (
          <>
            <Spinner animation="border" variant="primary" />
          
          </>
        ) : (
          <>
            {activationStatus.success ? (
              <>
                <CheckCircle size={64} className="text-success mb-3" />
                <h3 className="mb-2">Your account has been successfully activated.</h3>
    <p className="text-muted">You can now sign in and start using your account.</p>
                <Button variant="primary" className="mt-3" onClick={() => (window.location.href = '/signin')}>
                  Go to Sign In
                </Button>
              </>
            ) : (
              <>
                <XCircle size={64} className="text-danger mb-3" />
                <h3 className="mb-2">Activation Failed</h3>
                <p className="text-muted">{activationStatus.message}</p>
                
              </>
            )}
          </>
        )}
      </div>
    </Container>
  );
}

export default Activation;